{
  "strings": {
    "analysis": {
      "title": "Analysis",
      "save-reports-and-boards": {
        "title": "Save Reports and Boards",
        "description": "Allows members to save and edit reports and boards"
      },
      "create-custom-data-definitions": {
        "title": "Create Custom Data Definitions",
        "description": "Allows members to create, edit, and manage custom data definitions such as Cohorts, Metrics, Custom Events and Properties."
      },
      "manage-all-analysis-and-custom-definitions": {
        "title": "Manage All Analysis and Custom Data Definitions",
        "description": "Allows members to edit and manage any analysis or custom data definition in the project"
      },
      "pin-dashboards": {
        "title": "Pin Dashboards",
        "description": "Allows members to pin dashboards for the project."
      }
    },
    "feature-flags-and-experimentation": {
      "title": "Feature Flags and Experimentation",
      "experimentation-creation": {
        "title": "Experimentation Creation",
        "description": "Allows members to create and manage Mixpanel Experiments."
      },
      "launch-visual-experiments": {
        "title": "Launch Web Experiments",
        "description": "Allows members to launch Web Experiments."
      },
      "feature-flag-creation": {
        "title": "Feature Flag Creation",
        "description": "Allows members to create and manage Feature Flags."
      },
      "full-feature-flag-access": {
        "title": "Full Feature Flag Access",
        "description": "Allows members to create and manage all Feature Flags within the project."
      }
    },
    "data-management": {
      "title": "Data Management",
      "edit-metadata": {
        "title": "Edit Metadata",
        "description": "Allows members to edit event and property details such as description, images, and tags, and owners."
      },
      "set-event-and-property-visibility": {
        "title": "Set Event and Property Visibility",
        "description": "Allows members to hide or unhide events and properties in Lexicon."
      },
      "data-verification": {
        "title": "Data Verification",
        "description": "Allows members to control data verification in Lexicon."
      },
      "manage-schemas": {
        "title": "Manage Schemas",
        "description": "Allows members to upload and edit schemas in Lexicon."
      },
      "manage-lookup-tables": {
        "title": "Manage Lookup Tables",
        "description": "Allows members to create and edit lookup tables"
      },
      "mark-sensitive-data": {
        "title": "Mark Sensitive Data",
        "description": "Allows members to control which properties are classified. Does not grant access to view. "
      },
      "edit-profiles": {
        "title": "Edit Profiles",
        "description": "Allows members to edit user or group profiles."
      },
      "data-deletion-dropping-and-merging": {
        "title": "Data Deletion, Dropping, and Merging",
        "description": "Allows members to control advanced data deletion, merge and drop events. (Recommended for Project Owners/Admins only)"
      },
      "data-settings-access": {
        "title": "Data Settings Access",
        "description": "Allows members to edit Data Settings such as Data Volume Monitoring, Data Standards, and Event Approval."
      }
    },
    "data-access-exports-and-alerts": {
      "title": "Data Access, Exports, and Alerts",
      "public-boards": {
        "title": "Public Boards",
        "description": "If enabled in project settings, allows members to create public boards to share outside of their Mixpanel project."
      },
      "sensitive-data-access": {
        "title": "Sensitive Data Access",
        "description": "Allows access to properties that have been marked sensitive."
      },
      "exporting-lexicon": {
        "title": "Export Lexicon",
        "description": "Allows exporting data definitions from Lexicon"
      },
      "exporting-reports-csv": {
        "title": "Export Reports as CSV",
        "description": "Allows downloading report data (Insights, Funnels, etc.) as CSV"
      },
      "exporting-users-csv": {
        "title": "Export Users as CSV",
        "description": "Allows downloading user data from the Users page as CSV"
      },
      "exporting-events-csv": {
        "title": "Export Events as CSV",
        "description": "Allows downloading event data from the Events page as CSV"
      },
      "create-alerts": {
        "title": "Create Alerts",
        "description": "Allows members to create and manage their own alerts on reports and boards."
      },
      "create-board-subscriptions": {
        "title": "Create Board Subscriptions",
        "description": "Allows members to create and manage board subscriptions."
      },
      "manage-all-alerts": {
        "title": "Manage All Alerts",
        "description": "Allows members to create, edit, and delete any alert in the project, including alerts created by other members."
      }
    },
    "data-sources-and-definitions": {
      "title": "Data Sources and Definitions",
      "create-and-manage-destinations": {
        "title": "Create and Manage Destinations",
        "description": "Access to create and manage destination tools such as Cohort syncs and Data Pipelines to send data from Mixpanel to other destinations."
      },
      "create-and-manage-data-warehouses": {
        "title": "Create and Manage Data Warehouses",
        "description": "Access to create and manage Data Warehouse Connector Syncs into Mixpanel."
      }
    },
    "settings": {
      "title": "Settings and Notifications",
      "view-and-edit-project-settings": {
        "title": "View and Edit Project Settings",
        "description": "Allows members to edit project settings, create data views, view audit logs, create service accounts, and manage project members"
      }
    }
  },
  "requires": {
    "launch-visual-experiments": "experimentation-creation",
    "set-event-and-property-visibility": "edit-metadata",
    "data-verification": "edit-metadata"
  }
}
